@if (
  {
    row: columnData | async,
  };
  as $
) {
  @if ($.row.recurring_services) {
    <div class="flex align-items-center">
      <i class="fa fa-refresh mr-2"></i><span>Yes</span>
    </div>
  } @else {
    <div class="flex align-items-center">
      <i class="fa fa-ban mr-2"></i><span>No</span>
    </div>
  }
}
